import TableRow from '@mui/material/TableRow'
import Checkbox from '@mui/material/Checkbox'
import TableHead from '@mui/material/TableHead'
import React from 'react'
import {StyledTableHeader} from '@/components/common/CustomStyledComponents'

type DataInfoTableHeadProps = {
    headers: string[];
    allSelected?: boolean;
    onSelectAll?: (allSelected: boolean) => void;
    hideCheckbox?: boolean;
}

const DataInfoTableHead = ({headers, onSelectAll, allSelected, hideCheckbox = false}: DataInfoTableHeadProps) => {
    const handleClick = () => {
        if(onSelectAll) {
            onSelectAll(!allSelected)
        }
    }

    return (
        <TableHead>
            <TableRow>
                {!hideCheckbox && (
                    <StyledTableHeader padding="checkbox" $larger={true} $noVerticalBorder={true}>
                        <Checkbox
                            color="primary"
                            value={allSelected}
                            checked={!!allSelected}
                            onClick={handleClick}
                        />
                    </StyledTableHeader>
                )}
                {headers.map((header, index) => (
                    <StyledTableHeader key={'data-info-table-header-' + index} $larger={true} $noVerticalBorder={true}>{header}</StyledTableHeader>
                ))}
            </TableRow>
        </TableHead>
    )
}

export default DataInfoTableHead